import { downloadFile, getIdOrNull, requestMultipart } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'

export const setChatMessagePinned = (user, chatMessage, pinned) => {
  return apiClient.patch(user, `api/chat-messages/${getIdOrNull(chatMessage)}/pin`, { pinned })
}

export const uploadMessageFile = (user, chatMessage, file) => {
  return requestMultipart(
    `/api/chat-messages/${getIdOrNull(chatMessage)}/documents`,
    HttpMethods.POST,
    { file },
    user
  )
}

export const downloadMessageFile = (user, messageFile) => {
  return downloadFile(`/download/chat-message-documents/${getIdOrNull(messageFile)}`, messageFile.originalName, user, HttpMethods.GET)
}
